let React    = require('react');
let ReactDom = require('react-dom');

// -------------------------------------------------------

const ADMIN_LOGIN_URL = 'https://casting-space-manage.moribus.jp/';
// -------------------------------------------------------

class AdminMoved extends React.Component {
  render() {
    return (
      <div id="login">
        <div className="login-box">
          <div className="login-logo" />

          <div className="box">
            <div className="auth0-notice">
              <span className="material-icons notice-icon">info</span>
              <p className="notice-title">管理者はこのURLからログインに変更になりました</p>
              <p className="notice-desc">
                管理者の方のログイン先が変更されました。<br />
                下記のURLよりログインしてください。
              </p>
            </div>

            <a className="auth0-login-button" href={ADMIN_LOGIN_URL}>
              <span className="material-icons">lock_open</span>
              管理者ログインページへ
            </a>

            <a className="auth0-login-button logout" href="/logout">
              <span className="material-icons">logout</span>
              ログアウト
            </a>
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

export default AdminMoved;
